import styled from "styled-components";
import DropDownArrow from "../../assets/svg/arrows/DropDownArrow";

export const RotatingDropDownArrow = styled(DropDownArrow)`
  transition: transform ${(props) => props.transitionSpeed || "0.2s"} ease;
  transform: ${({ isActive, fromDegree, toDegree }) =>
    !isActive ? `rotate(${fromDegree}deg)` : `rotate(${toDegree}deg)`};
  transform-origin: 50% 50%;

  margin-top: 4px;
  margin-left: 7px;
`;

export const GreymattersHeaderName = styled.section`
  color: ${(props) => props.fontColor || "var(--white, #fff)"};
  font-family: Valizas;
  font-size: 24px;
  font-style: normal;
  font-weight: 650;
  line-height: normal;

  margin: 0 16px;

  @media (max-width: 1400px) {
    font-size: 20px;
  }

  @media (max-width: 1079px) {
    font-size: 24px;
  }
`;
